import z from "zod";
//
// Entity
//
export const DTOWorkspaceSsoSettings = z.object({
    providerId: z.string(),
    defaultAutoInviteValue: z.boolean(),
    autoInviteDomains: z.record(z.string(), z.boolean()),
    areInvitesDisabled: z.boolean(),
    skipDocsSupernovaLogin: z.boolean(),
    emailDomains: z.array(z.string()),
    metadataXml: z.string().nullish(),
    isScimEnabled: z.boolean(),
    scimBaseUrl: z.string().optional(),
});
//
// Payloads
//
export const DTOWorkspaceSsoSettingsUpdate = z.object({
    defaultAutoInviteValue: z.boolean().optional(),
    autoInviteDomains: z.record(z.string(), z.boolean()).optional(),
    areInvitesDisabled: z.boolean().optional(),
    skipDocsSupernovaLogin: z.boolean().optional(),
    isScimEnabled: z.boolean().optional(),
    emailDomains: z.array(z.string()).optional(),
});
export const DTOWorkspaceSsoSettingsResponse = z.object({
    ssoSettings: DTOWorkspaceSsoSettings.optional(),
});
